<template>
    <div class="container">
        <slot></slot>
        <div v-if="menu" class="payment-menu">
            <div class="menu-item" :class="item.active ? 'menu-item-active' : ''"
                 v-for="item in menus" :key="item.name" @click="handleMenu(item)">
                <a-icon style="font-size: 20px" :type="item.icon"/>
                <div class="item-name">{{item.name}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MyPaymentRecord",
    props: {
        menu: {
            type: Boolean,
            default() {return true}
        }
    },
    data() {
        return {
            menus: [{
                active: false,
                name: '统计',
                icon: 'pie-chart',
                path: '/payment/reports'
            },{
                active: false,
                name: '明细',
                icon: 'file-done',
                path: '/payment/records'
            },]
        }
    },
    watch: {
        $route(to) {
            this.menus.forEach(menu => {
                menu.active = (menu.path === to.path)
            })
        }
    },
    created() {
        this.menus.forEach(menu => {
            menu.active = (menu.path === this.$route.path)
        })
    },
    methods: {
        handleMenu(item) {
            if (item.active) {
                return;
            }
            this.menus.forEach(menu => menu.active = false);
            item.active = true;
            this.$router.push(item.path);
        }
    }
}
</script>

<style lang="less" scoped>
.container {
    max-width: 500px;
    margin: 0 auto;
    min-height: 100vh;
    background: #fff;
    position: relative;
    box-sizing: border-box;
    .payment-menu {
        position: fixed;
        z-index: 999999999;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 500px;
        height: 80px;
        background: #fff;
        box-sizing: border-box;
        border: 1px solid #EBEBECFF;
        display: flex;
        .menu-item {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            cursor: pointer;
            user-select: none;
            .item-name {
                padding-top: 3px;
            }
        }
        .menu-item-active {
            color: #3EB475FF;
        }
    }
}

</style>
